import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  sectionTitle: (props) => ({
    padding: theme.spacing(1),
    backgroundColor: props?.sectionColor,
    display: 'inline-block',
    '& .MuiTypography-root': {
      fontFamily: 'Libre Franklin, serif',
      fontWeight: 600,
      color: '#1A1A1F',
    },
  }),
}));
